import { ContentApi } from '@/api';

const state = {
  // Store AI history data
  videoHistoryData: null,
  currentContentId: null,
  currentContentType: null,
  isLoading: false,
  error: null
};

const mutations = {
  SET_VIDEO_HISTORY_DATA(state, data) {
    state.videoHistoryData = data;
  },

  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },

  SET_CURRENT_CONTENT(state, { contentId, contentType }) {
    state.currentContentId = contentId;
    state.currentContentType = contentType;
  },

  CLEAR_VIDEO_HISTORY(state) {
    state.videoHistoryData = null;
    state.currentContentId = null;
    state.currentContentType = null;
    state.isLoading = false;
    state.error = null;
  }
};

const actions = {
  // Fetch video history for specific content (one-time call, no polling)
  async fetchVideoHistory({ commit }, { contentId, contentType }) {
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      commit('SET_CURRENT_CONTENT', { contentId, contentType });

      const response = await ContentApi.getAiHistory({ type: contentType, id: contentId });

      commit('SET_VIDEO_HISTORY_DATA', response.data);

      return response.data;
    } catch (error) {
      console.error('Error fetching video history:', error);
      commit('SET_ERROR', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Load video history for specific content
  async loadVideoHistory({ dispatch }, { contentId, contentType }) {
    return await dispatch('fetchVideoHistory', { contentId, contentType });
  },

  // Clear video history
  clearVideoHistory({ commit }) {
    commit('CLEAR_VIDEO_HISTORY');
  }
};

const getters = {
  getVideoHistoryData: state => state.videoHistoryData,
  getCurrentContent: state => ({
    contentId: state.currentContentId,
    contentType: state.currentContentType
  }),
  isVideoHistoryLoading: state => state.isLoading,
  videoHistoryError: state => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
